import { render, staticRenderFns } from "./compra_orden_trabajo.vue?vue&type=template&id=44a50d32"
import script from "./compra_orden_trabajo.vue?vue&type=script&lang=js"
export * from "./compra_orden_trabajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports